import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ColumnSelector from 'components/ColumnSelector';

const ListCutterJobSelectColumns = ({ availableColumns, selectedColumns, onSelectedColumnsChange }) => {
  const hasError = selectedColumns.length === 0;

  return (
    <Box>
      {hasError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Please select at least one column for the output.
        </Alert>
      )}
      <Typography variant="h4" sx={{ mb: 1 }}>
        Select Columns
      </Typography>
      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        Double-click columns to add or remove them. Only selected columns listed on the right will be included in your new list.
      </Typography>
      <ColumnSelector
        availableColumns={availableColumns}
        selectedColumns={selectedColumns}
        onSelectedColumnsChange={onSelectedColumnsChange}
      />
    </Box>
  );
};

export default ListCutterJobSelectColumns; 